import Image from 'next/image';
import React from 'react';
import { cn } from '../lib/utils';

export default function Logo({ className }) {
  return <Image src='/logo-stacked.png' width={300} height={300} alt='TCG Stacked' className={cn('max-w-[65px]', className)} />;
}
